module.exports = __webpack_public_path__ + "static/media/028-ER18_1v9qYVqvffz8qmNWJGyUzishQm2GJHV1y.15212aa9.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/028-ER18_1v9qYVqvffz8qmNWJGyUzishQm2GJHV1y
// module id = 684
// module chunks = 0